const allowed = [
  "modern-dark",
  "light",
  "neon",
  "premium",
];

// Deliberately has no game state, timers, navigation, or score-room dependency.
export function createScoreboardAppearanceSync({
  socket,
  load,
  onChange,
  onError = () => {},
  pollMs = 30000,
}) {
  let stopped = false;
  let request = 0;
  let current = null;
  const join = () => {
    if (current?.club_id && socket.connected)
      socket.emit("joinScoreboardClub", current.club_id);
  };
  const refresh = async () => {
    if (stopped) return;
    const ticket = ++request;
    try {
      const value = await load();
      if (stopped || ticket !== request) return;
      if (
        !value ||
        !allowed.includes(value.theme) ||
        !Number.isSafeInteger(Number(value.club_id)) ||
        Number(value.club_id) <= 0
      ) {
        throw new Error("Invalid scoreboard appearance");
      }
      if (current?.club_id && String(current.club_id) !== String(value.club_id))
        socket.emit("leaveScoreboardClub", current.club_id);
      const changed = JSON.stringify(current) !== JSON.stringify(value);
      current = value;
      join();
      if (changed) onChange(value);
    } catch (error) {
      if (!stopped && ticket === request) onError(error);
    }
  };
  const connected = () => {
    join();
    refresh();
  };
  const changed = (event) => {
    if (
      current &&
      String(event?.club_id) === String(current.club_id) &&
      (event.game_id == null ||
        String(event.game_id) === String(current.game_id))
    )
      refresh();
  };
  socket.on("connect", connected);
  socket.on("scoreboardThemeChanged", changed);
  const interval = setInterval(refresh, pollMs);
  refresh();
  socket.connect();
  return {
    refresh,
    dispose() {
      stopped = true;
      request += 1;
      clearInterval(interval);
      socket.off("connect", connected);
      socket.off("scoreboardThemeChanged", changed);
      if (current?.club_id) socket.emit("leaveScoreboardClub", current.club_id);
      socket.disconnect();
    },
  };
}
